export default __webpack_public_path__ + "static/MYcovercopy-s-fb661ce0f19a61356006c0a0829c8645.jpg";